export const companyApi = {
    list: {
        method: 'post',
        api: 'admin/companys/list'
    },
    alllist: {
        method: 'post',
        api: 'admin/companys/alllist'
    },
    get: {
        method: 'post',
        api: 'admin/companys/get'
    },
    add: {
        method: 'post',
        api: 'admin/companys/add'
    },
    edit: {
        method: 'post',
        api: 'admin/companys/edit'
    },
    del: {
        method: 'post',
        api: 'admin/companys/del'
    },
    changeStatus: {
        method: 'post',
        api: 'admin/companys/change_status'
    },
    get_cates_list: {
        method: 'post',
        api: 'admin/companys/get_cates_list'
    },
    add_cate: {
        method: 'post',
        api: 'admin/companys/add_cate'
    },
    edit_cate: {
        method: 'post',
        api: 'admin/companys/edit_cate'
    },
    del_cate: {
        method: 'post',
        api: 'admin/companys/del_cate'
    },
    setEndTime: {
        method: 'post',
        api: 'admin/companys/set_end_time'
    },
    getLogList: {
        method: 'post',
        api: 'admin/companys/get_log_list'
    },
  }